import React from 'react';
import { Page } from '../Page';
import { Heart, Brain, Shield } from 'lucide-react';
export function SupplementOmega3() {
  return <Page pageNumber={17} variant="light" data-id="element-2621">
      <div className="flex h-full gap-10" data-id="element-2622">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-2623">
          <img src="https://cdn.magicpatterns.com/uploads/3KbmboHJcX9JxXqrqDKoJB/pasted-image.png" alt="Thorne Omega-3 with CoQ10" className="w-full max-w-[280px] object-contain" data-id="element-2624" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-2625">
          <div className="mb-6 pt-4" data-id="element-2626">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-2627">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-2628">
              Omega-3 with CoQ10
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-2629">
              Anti-inflammatory + cardiovascular protection
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-2630" />
          </div>

          <div className="mb-8" data-id="element-2631">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-2632">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-2633">
              Rapid weight loss triggers an inflammatory response throughout the
              body. Omega-3 fatty acids (EPA + DHA) support a healthy
              inflammatory response, protect cardiovascular health, and maintain
              brain function during caloric deficit. The added CoQ10 enhances
              absorption and provides synergistic cellular energy support.
            </p>
          </div>

          <div className="mb-8" data-id="element-2634">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-2635">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-2636">
              <li className="flex gap-2" data-id="element-2637">
                <Heart className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2638" />
                <span data-id="element-2639">
                  Supports cardiovascular health, promoting healthy blood vessel
                  function, cholesterol, and triglyceride levels
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2640">
                <Shield className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2641" />
                <span data-id="element-2642">
                  Promotes a healthy inflammatory response during the metabolic
                  stress of weight loss
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2643">
                <Brain className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2644" />
                <span data-id="element-2645">
                  Supports brain function and protects against oxidative stress
                  during caloric deficit
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2646">
                <span className="text-tealslate shrink-0" data-id="element-2647">•</span>
                <span data-id="element-2648">
                  Two supplements in one, molecularly distilled fish oil + CoQ10
                  for enhanced absorption, NSF Certified
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-2649">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-2650">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-2651">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-2652">
                <strong data-id="element-2653">1 gelcap, 2-3 times daily</strong> with meals
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-2654">
                450mg EPA + 180mg DHA + 30mg CoQ10 per gelcap • 90 gelcaps per
                bottle
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-2655">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-2656" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-2657">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}